const initialState = {
    corporatePermissions: {},
    corporateLists: [],
    corporateHighlightedRecord: null,
    corporateDetails: [],
    corporateViewDetails: [],
    corporateStatus: [],
    changedCorporateStatus: [],
    corporateID:null,
    loadingCorporate: false,
    loadingCorporateSocial: false,
    loadingCorporateVerification: false,
    loadingCorporateCompanyDetail: false,
    loadingCorporateAlert: false,
    loadingCorporateGrievance: false,
    loadingBlacklistCorporate: false,
    errorsCorporate: {},
    errorsCorporateSocial: {},
    errorsCorporateVerification: {},
    errorsCorporateCompanyDetail: {},
    errorsCorporateAlert: {},
    errorsCorporateGrievance: {},
    errorsBlacklistCorporate: {},
}

const corporateReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_CORPORATELIST_PENDING":
        case "ADD_CORPORATE_PENDING":
        case "UPDATE_CORPORATE_PENDING":
        case "UPDATE_CORPORATE_STATUS_PENDING":
        case "UPDATE_CORPORATE_SOCIALMEDIA_PENDING":
        case "DELETE_CORPORATE_PENDING":
        case "GET_CORPORATELISTBYID_PENDING":
        case "GET_CORPORATEVIEWBYID_PENDING":
            return { ...state, loadingCorporate: true };
        case "CORPORATE_VERIFICATION_PENDING":
            return { ...state, loadingCorporateVerification: true };
        case "CORPORATE_COMAPNYDETAILS_PENDING":
            return { ...state, loadingCorporateCompanyDetail: true };
        case "CORPORATE_ALERT_PENDING":
            return { ...state, loadingCorporateAlert: true };
        case "CORPORATE_GRIEVANCE_PENDING":
            return { ...state, loadingCorporateGrievance: true };
        case "CORPORATE_BLACKLIST_PENDING":
            return { ...state, loadingBlacklistCorporate: true };

        case "GET_CORPORATELIST_FULFILLED":
            return {
                ...state,
                loadingCorporate: false,
                corporateLists: action.payload,
                corporateCount: action.count,
                corporatePermissions: action.permissions,
            };

        case "ADD_CORPORATE_FULFILLED":
            return {
                ...state,
                loadingCorporate: false,
                changedCorporateStatus: action.payload,
                corporateID:action.payload.data.id,
            };

        case "UPDATE_CORPORATE_FULFILLED":
            return {
                ...state,
                loadingCorporate: false,
                changedCorporateStatus: action.payload,
            };

        case "UPDATE_CORPORATE_STATUS_FULFILLED":
            return {
                ...state,
                loadingCorporate: false,
                changedCorporateStatus: action.payload,
            };

        case "GET_CORPORATELISTBYID_FULFILLED":
            return {
                ...state,
                loadingCorporate: false,
                corporateDetails: action.payload
            };

        case "GET_CORPORATEVIEWBYID_FULFILLED":
            return {
                ...state,
                loadingCorporate: false,
                corporateViewDetails: action.payload
            };

        case "DELETE_CORPORATE_FULFILLED":
            return {
                ...state,
                loadingCorporate: false,
                changedCorporateStatus: action.payload
            };

        case "RESET_DELETE_CORPORATES_STATUS":
            return {
                ...state,
                loadingCorporate: false,
                changedCorporateStatus: [],
                errorsCorporate: {}
            };

        case "GET_CORPORATELIST_REJECTED":
        case "ADD_CORPORATE_REJECTED":
            return {
                ...state,
                loadingCorporate: false,
                changedCorporateStatus: [],
                errorsCorporate: action.payload
            };
        case "UPDATE_CORPORATE_SOCIALMEDIA_FULFILLED":
            return {
                ...state,
                loadingCorporateSocial: false,
                changedCorporateStatus: action.payload,
                errorsCorporateSocial: {}
            };
        case "CORPORATE_VERIFICATION_FULFILLED":
            return {
                ...state,
                loadingCorporateVerification: false,
                changedCorporateStatus: action.payload,
                errorsCorporateVerification: {}
            };
        case "CORPORATE_COMAPNYDETAILS_FULFILLED":
            return {
                ...state,
                loadingCorporateCompanyDetail: false,
                changedCorporateStatus: action.payload,
                errorsCorporateCompanyDetail: {}
            };
        case "CORPORATE_ALERT_FULFILLED":
            return {
                ...state,
                loadingCorporateAlert: false,
                changedCorporateStatus: action.payload,
                errorsCorporateAlert: {}
            };
        case "CORPORATE_GRIEVANCE_FULFILLED":
            return {
                ...state,
                loadingCorporateGrievance: false,
                changedCorporateStatus: action.payload,
                errorsCorporateGrievance: {}
            };
        case "CORPORATE_BLACKLIST_FULFILLED":
            return {
                ...state,
                loadingBlacklistCorporate: false,
                changedCorporateStatus: action.payload,
                errorsBlacklistCorporate: {}
            };
        case "UPDATE_CORPORATE_REJECTED":
        case "UPDATE_CORPORATE_STATUS_REJECTED":
        case "DELETE_CORPORATE_REJECTED":
        case "GET_CORPORATELISTBYID_REJECTED":
        case "GET_CORPORATEVIEWBYID_REJECTED":
            return {
                ...state,
                loadingCorporate: false,
                errorsCorporate: action.payload
            };
        case "UPDATE_CORPORATE_SOCIALMEDIA_REJECTED":
            return {
                ...state,
                loadingCorporateSocial: false,
                errorsCorporateSocial: action.payload
            };
        case "CORPORATE_VERIFICATION_REJECTED":
            return {
                ...state,
                loadingCorporateVerification: false,
                errorsCorporateVerification: action.payload
            };
        case "CORPORATE_COMAPNYDETAILS_REJECTED":
                return {
                    ...state,
                    loadingCorporateCompanyDetail: false,
                    changedCorporateStatus: [],
                    errorsCorporateCompanyDetail: action.payload,
                };
        case "CORPORATE_COMAPNYDETAILS_REJECTED":
                return {
                    ...state,
                    loadingCorporateAlert: false,
                    changedCorporateStatus: [],
                    errorsCorporateAlert : action.payload,
                };
        case "CORPORATE_GRIEVANCE_REJECTED":
                return {
                    ...state,
                    loadingCorporateGrievance: false,
                    changedCorporateStatus: [],
                    errorsCorporateGrievance : action.payload,
                };
        case "CORPORATE_BLACKLIST_REJECTED":
                return {
                    ...state,
                    loadingBlacklistCorporate: false,
                    changedCorporateStatus: [],
                    errorsBlacklistCorporate : action.payload,
                };
        case "SET_CORPORATE_HIGHLIGHTED_RECORD":
                return {
                    ...state,
                    corporateHighlightedRecord: action.payload,
                };
        case "CLEAR_CORPORATE_HIGHLIGHTED_RECORD":
                return {
                    ...state,
                    corporateHighlightedRecord: null,
                };
        case "RESET_DELETE_CORPORATE_STATUS":
                return {
                    ...state,
                    loadingCorporateCompanyDetail: false,
                    changedCorporateStatus: [],
                    errorsCorporate: {},
                    errorsCorporateSocial: {},
                    errorsCorporateVerification: {},
                    errorsCorporateCompanyDetail: {},
                    errorsCorporateAlert: {},
                    errorsCorporateGrievance: {},
                    errorsBlacklistCorporate: {}
                };

        case "CLEAR_CORPORATE_DETAILS":
                return {
                    ...state,
                    corporateDetails: {},
                    corporateViewDetails: {},
                    corporateID: null
                };

        default:
            return state;
    }
}

export default corporateReducer;